import BaseModal from "../common/HPBaseModal";
import SyncIcon from "@mui/icons-material/Sync";
import { ModalProps } from "@_constants/modal";
import { useAppDispatch } from "@/store";
import { modalDispatcher } from "@/store/slices/modal-slice";
import { t } from "@utils/i18n";

interface SurveysUpdateListModalProps extends ModalProps {
  isRefreshing: boolean;
  action: () => void;
}
const SurveysUpdateListModal: React.FC<SurveysUpdateListModalProps> = ({
  isRefreshing,
  action,
}) => {
  const dispatch = useAppDispatch();
  const { closeTopModal } = modalDispatcher(dispatch);
  return (
    <BaseModal
      loading={isRefreshing}
      title={t("modals.updateSurveysList.title")}
      message={t("modals.updateSurveysList.message")}
      onConfirm={action}
      onCancel={closeTopModal}
      confirmButtonText={t("modals.updateSurveysList.confirmButton")}
      cancelButtonText={t("modals.updateSurveysList.cancelButton")}
      confirmButtonIcon={<SyncIcon className="text-hp-bg-primary" />}
    />
  );
};

export default SurveysUpdateListModal;
